import { Helmet } from 'react-helmet-async';
import { sendGAPageview } from '../utils/gaConsent';
import APIContent from '../components/API/APIContent';
import { userAppContext } from '../context/Context';
import $ from 'jquery';
import { useNavigate } from 'react-router-dom';

export default function Api() {
  const navigate = useNavigate();
  $('.popover').hide();

  const { isAuthenticated } = userAppContext();

  if (!isAuthenticated) {
    navigate('/login', { replace: true });
    return null;
  }

  sendGAPageview({ hitType: 'pageview', page: '/Tools', title: 'Tools' });

  return (
    <>
      <Helmet>
        <title>DISGENET: Our API and database tools</title>
        <meta name="description" content="DISGENET offers different tools to acces the database." />
        <meta property="og:title" content="DISGENET: Our API and database tools" />
        <meta
          property="og:description"
          content="Explore the various tools provided by DISGENET to access the database and enhance your research."
        />
        <meta property="og:url" content="https://www.disgenet.com/Tools" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/Tools" />
      </Helmet>
      <div className="container">
        <APIContent />
      </div>
    </>
  );
}
